<h1>Writer Publisher Rows</h1>
<div class="components-container">
  
  <!-- Seção: Compositores e Editoras (Padrão) -->
  <div>
    <h3>Compositores e Editoras (Padrão)</h3>
    <p class="description">Formato usado para exibir compositores e editoras com avatar, nome, tipo, direitos autorais e percentual.</p>
    
    @for (writer of writersPublishers; track writer.id) {
      <div class="writer-publisher">
        <div class="main">
          <div class="name">{{ writer.name }}</div>
          <p>{{ writer.type }}</p>
          <p>{{ writer.rightsType }}</p>
        </div>
        <div class="actions">
          @if (writer.hasSpotifyId) {
            <mzic-svg
              title="Perfil Spotify vinculado"
              src="assets/icons/mzic-spotify-icon.svg" />
          }
          @if (writer.hasAppleId) {
            <mzic-svg
              title="Perfil Apple Music vinculado"
              src="assets/icons/mzic-apple-music-icon.svg" />
          }
          <div class="percent">{{ writer.percentage }}%</div>
          <button
            (click)="removeItem(writer)"
            class="mz-button only-icon small secondary delete">
            <mzic-svg src="assets/icons/mzic-trash.svg" />
          </button>
        </div>
      </div>
    }
  </div>

  <!-- Seção: Arquivos/Partituras (Com Ícone) -->
  <div>
    <h3>Arquivos/Partituras (Com Ícone)</h3>
    <p class="description">Formato usado para exibir arquivos como partituras, letras, etc. com ícone à esquerda, nome do arquivo e tamanho.</p>
    
    @for (file of files; track file.id) {
      <div class="writer-publisher">
        <div class="main-icon-container">
          <div class="icon">
            <mzic-svg
              [src]="'assets/icons/' + file.icon"
              class="purple-500 stroke w12" />
          </div>
          <div class="main">
            <div class="name">{{ truncateFileName(file.name!) }}</div>
            <p>{{ file.size }}</p>
          </div>
        </div>
        <div class="actions">
          <button
            (click)="downloadFile(file)"
            class="mz-button only-icon small tertiary"
            title="Download arquivo">
            <mzic-svg src="assets/icons/mzic-download.svg" />
          </button>
          <button
            (click)="removeItem(file)"
            class="mz-button only-icon small secondary delete">
            <mzic-svg src="assets/icons/mzic-trash.svg" />
          </button>
        </div>
      </div>
    }
  </div>

  <!-- Seção: Estados de Erro e Aviso -->
  <div>
    <h3>Estados de Erro e Aviso</h3>
    <p class="description">Mensagens que aparecem para orientar o usuário sobre problemas ou avisos relacionados aos percentuais.</p>
    
    <h4>Mensagens com Background e Ícone</h4>
    @for (error of errorMessages; track $index) {
      @if (error.type !== 'soft-error') {
        <div class="writers-publishers-warning-msg" [class]="error.type">
          {{ error.message }}
        </div>
      }
    }

    <h4>Mensagens Soft Error (Apenas Texto Vermelho)</h4>
    <p class="description">Versão mais sutil sem padding, background, border ou ícone - apenas texto vermelho.</p>
    @for (error of errorMessages; track $index) {
      @if (error.type === 'soft-error') {
        <div class="soft-error">
          {{ error.message }}
        </div>
      }
    }
  </div>

  <!-- Seção: Variações de Ícones -->
  <div>
    <h3>Variações de Ícones Disponíveis</h3>
    <p class="description">Diferentes ícones que podem ser usados para representar tipos de arquivo ou ações.</p>
    
    @for (icon of availableIcons; track $index) {
      <div class="writer-publisher">
        <div class="main-icon-container">
          <div class="icon">
            <mzic-svg
              [src]="'assets/icons/' + icon"
              class="purple-500 stroke w12" />
          </div>
          <div class="main">
            <div class="name">{{ icon.replace('.svg', '').replace('mzic-', '') }}</div>
            <p>Exemplo de uso</p>
          </div>
        </div>
        <div class="actions">
          <button class="mz-button only-icon small secondary delete">
            <mzic-svg src="assets/icons/mzic-trash.svg" />
          </button>
        </div>
      </div>
    }
  </div>

  <!-- Seção: Estados Interativos -->
  <div>
    <h3>Estados Interativos</h3>
    <p class="description">Demonstração dos diferentes estados visuais do componente.</p>
    
    <!-- Estado Normal -->
    <h4>Estado Normal</h4>
    <div class="writer-publisher">
      <div class="main">
        <div class="name">Estado Normal</div>
        <p>Compositor</p>
        <p>Mechanical Rights</p>
      </div>
      <div class="actions">
        <div class="percent">50%</div>
        <button class="mz-button only-icon small secondary delete">
          <mzic-svg src="assets/icons/mzic-trash.svg" />
        </button>
      </div>
    </div>

    <!-- Estado Hover (simulado) -->
    <h4>Estado Hover (simulado)</h4>
    <div class="writer-publisher hover-demo">
      <div class="main">
        <div class="name">Estado Hover</div>
        <p>Editora</p>
        <p>Publishing Rights</p>
      </div>
      <div class="actions">
        <div class="percent">30%</div>
        <button class="mz-button only-icon small secondary delete hover">
          <mzic-svg src="assets/icons/mzic-trash.svg" />
        </button>
      </div>
    </div>
  </div>

  <!-- Seção: Exemplos de Uso Futuro - Erro -->
  <div>
    <h3>Exemplo de Uso Futuro - Componente com Erro</h3>
    <p class="description">Demonstração de como o componente pode ser envolvido por uma mensagem de erro para validações futuras.</p>
    
    <div class="error-wrapper">
      <div class="error-border">
        <div class="writer-publisher">
          <div class="main">
            <div class="name">Item com Erro</div>
            <p>Compositor</p>
            <p>Dados inválidos</p>
          </div>
          <div class="actions">
            <div class="percent error">150%</div>
            <button class="mz-button only-icon small secondary delete">
              <mzic-svg src="assets/icons/mzic-trash.svg" />
            </button>
          </div>
        </div>
      </div>
      <div class="error-message">
        <mzic-svg src="assets/icons/mzic-close-filled.svg" class="red" />
        O percentual não pode exceder 100%
      </div>
    </div>
  </div>

  <!-- Seção: Exemplo de Uso Futuro - Soft Error -->
  <div>
    <h3>Exemplo de Uso Futuro - Componente com Soft Error</h3>
    <p class="description">Demonstração de validação mais sutil usando apenas texto vermelho, sem bordas ou backgrounds.</p>
    
    <div class="error-wrapper">
      <div class="error-border">
        <div class="writer-publisher">
          <div class="main-icon-container">
            <div class="icon">
              <mzic-svg src="assets/icons/mzic-download.svg" class="purple-500 stroke w12" />
            </div>
            <div class="main">
              <div class="name">nomedoarquivo.pdf</div>
              <p>300 KB</p>
            </div>
          </div>
          <div class="actions">
            <button class="mz-button only-icon small secondary delete">
              <mzic-svg src="assets/icons/mzic-trash.svg" />
            </button>
          </div>
        </div>
      </div>
      <div class="soft-error">
        Não foi possível concluir o envio. Verifique o formato do arquivo e tente novamente.
      </div>
    </div>
  </div>

  <!-- Seção: Layout Responsivo -->
  <div>
    <h3>Comportamento em Telas Menores</h3>
    <p class="description">Como o componente se adapta em diferentes tamanhos de tela.</p>
    
    <div class="mobile-demo">
      <div class="writer-publisher mobile">
        <div class="main">
          <div class="name">Layout Mobile</div>
          <p>Compositor</p>
          <p>Mechanical Rights</p>
        </div>
        <div class="actions">
          <div class="percent">25%</div>
          <button class="mz-button only-icon small secondary delete">
            <mzic-svg src="assets/icons/mzic-trash.svg" />
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Seção: Código de Exemplo -->
  <div>
    <h3>Estrutura HTML</h3>
    <p class="description">Estrutura básica do componente para implementação.</p>
    
    <div class="code-example">
      <h4>Compositor/Editora:</h4>
      <pre><code>&lt;div class="writer-publisher"&gt;
  &lt;div class="main"&gt;
    &lt;div class="name"&gt;Nome do Compositor&lt;/div&gt;
    &lt;p&gt;Tipo (Compositor/Editora)&lt;/p&gt;
    &lt;p&gt;Tipo de Direito Autoral&lt;/p&gt;
  &lt;/div&gt;
  &lt;div class="actions"&gt;
    &lt;div class="percent"&gt;50%&lt;/div&gt;
    &lt;button class="delete"&gt;🗑️&lt;/button&gt;
  &lt;/div&gt;
&lt;/div&gt;</code></pre>

      <h4>Arquivo/Partitura:</h4>
      <pre><code>&lt;div class="writer-publisher"&gt;
  &lt;div class="main-icon-container"&gt;
    &lt;div class="icon"&gt;
      &lt;mzic-svg src="assets/icons/mzic-download.svg" /&gt;
    &lt;/div&gt;
    &lt;div class="main"&gt;
      &lt;div class="name"&gt;arquivo.pdf&lt;/div&gt;
      &lt;p&gt;1.2 MB&lt;/p&gt;
    &lt;/div&gt;
  &lt;/div&gt;
  &lt;div class="actions"&gt;
    &lt;button class="delete"&gt;🗑️&lt;/button&gt;
  &lt;/div&gt;
&lt;/div&gt;</code></pre>

      <h4>Mensagens de Erro:</h4>
      <pre><code>&lt;!-- Erro com background e ícone --&gt;
&lt;div class="writers-publishers-warning-msg error"&gt;
  Os percentuais excedem 100%. Por favor, ajuste os valores.
&lt;/div&gt;

&lt;!-- Soft Error (apenas texto vermelho) --&gt;
&lt;div class="soft-error"&gt;
  Este campo é obrigatório.
&lt;/div&gt;</code></pre>
    </div>
  </div>
</div>